export default (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return {
        ...state,
        userData: action.stateData.userData,
      };

    case "LOGOUT":
      return action.initialState;

    case "INIT_USER":
      return {
        ...state,
        userData: action.userData,
      };

    case "UPDATE_USER":
      return {
        ...state,
        userData: {
          ...state.userData,
          ...action.updatedUserData,
        },
      };

    case "OPEN_CREATE_FOLDER_MODAL":
      return {
        ...state,
        createFolderModalIsOpen: true,
      };

    case "CLOSE_CREATE_FOLDER_MODAL":
      return {
        ...state,
        createFolderModalIsOpen: false,
      };

    case "OPEN_MOVE_MODAL":
      return {
        ...state,
        moveModalIsOpen: true,
        moveEntityType: action.entityType,
        moveEntity: action.entity,
      };

    case "CLOSE_MOVE_MODAL":
      return {
        ...state,
        moveModalIsOpen: false,
      };

    case "SET_MOVE_ENTITY_TYPE":
      return {
        ...state,
        moveEntityType: action.entityType,
      };

    default:
      console.log("No case matched, returning existing state");
      console.log(state);
      return state;
  }
};
